// @flow
import styled from 'styled-components';

export const PickerContainer = styled.div`
    height: 80%;
    margin: 10%;
    width: 80%;

    & > div > div {
        transform: scale(1.5) translate(0, 25%);
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/schedule-type/na-thermostat-cool/style.js